import { useContext } from 'react';
import { get, isEmpty } from 'lodash';
import { TCategory } from './constants';
import { _getCode, _getApplyStatus, _getSubjectApply, _getCourse } from 'api';
import { useFetch } from 'hooks';
import { HASH } from './constants';
import OptionsContext from 'optionsContext';

/**
 * @param  {TCategory} category
 * @param  {boolean=false} pauseRequest
 */
export const useOptions = (category: TCategory, pauseRequest: boolean = false, parentCodeKey: string = '-1') => {
  const { $optionStore, $setOptionStore, $setHashStore } = useContext<any>(OptionsContext);

  const isExist = !isEmpty($optionStore[category]);
  const specialCategoryMap = {
    SchoolSubjectApply: {
      // 获取驾校报审科目列表(阶段报审)
      request: _getSubjectApply,
    },
    SubjectApplyStatus: {
      // 获取驾校阶段核实状态
      request: _getApplyStatus,
    },
    combo: {
      // 驾校课程类型
      request: _getCourse,
    },
  };
  const { data } = useFetch({
    request: get(specialCategoryMap, `${category}.request`) || _getCode,
    query: get(specialCategoryMap, `${category}.request`)
      ? get(specialCategoryMap, `${category}.query`, {})
      : { codeType: category, parentCodeKey: parentCodeKey },
    forceCancel: pauseRequest || isExist,
    callback: (data) => {
      const options = (data || []).map((x: any) => ({ value: x.value, label: x.text }));
      const hash = options.reduce((acc: any, x: any) => Object.assign(acc, { [x.value]: x.label }), {});

      $setOptionStore((pre: any) => ({ ...pre, [category]: options }));
      $setHashStore((pre: any) => ({ ...pre, [category]: hash }));
    },
  });

  if (isExist) {
    return $optionStore[category] as IOption[];
  }

  return (pauseRequest
    ? HASH[category]
    : (data || []).map((x: any) => {
        return { value: x.value, label: x.text };
      })) as IOption[];
};
